import React from 'react';
import { useCountUp } from './ui/useCountUp';
import { RevealGroup, RevealItem } from './ui/Reveal';

interface Stat {
    value: number;
    suffix?: string;
    prefix?: string;
    label: string;
}

const stats: Stat[] = [
    { value: 50, suffix: '+', label: 'Automations shipped' },
    { value: 12000, suffix: '+', label: 'Manual hours saved / year' },
    { value: 60, suffix: '%', label: 'Avg. cost reduction' },
    { value: 99, suffix: '.9%', label: 'Workflow uptime' },
];

const StatCard: React.FC<{ stat: Stat }> = ({ stat }) => {
    const { ref, value } = useCountUp(stat.value);
    const display = value >= 1000 ? value.toLocaleString('en-US') : value;
    return (
        <RevealItem className="text-center px-4">
            <div className="font-display text-4xl md:text-5xl font-bold text-white tracking-tight tabular-nums">
                {stat.prefix}
                <span ref={ref}>{display}</span>
                <span className="text-gradient">{stat.suffix}</span>
            </div>
            <div className="mt-2 text-sm text-text-muted">{stat.label}</div>
        </RevealItem>
    );
};

const Stats: React.FC = () => {
    return (
        <section className="relative py-16 border-y border-white/[0.06] bg-navy-950/40">
            <div className="container-x">
                <RevealGroup className="grid grid-cols-2 lg:grid-cols-4 gap-y-10 divide-white/[0.06] lg:divide-x">
                    {stats.map((stat) => (
                        <StatCard key={stat.label} stat={stat} />
                    ))}
                </RevealGroup>
            </div>
        </section>
    );
};

export default Stats;
